import type { TFunction } from '../../contexts/translation-context';

import { type RadioGroupFieldOption } from './radio-group-field-props';

export const OTHER_ID = 'Other';

const getIsValueFromOptions = (
  options: RadioGroupFieldOption[],
  value?: string | null,
) => options?.find((option) => option.label === value);

export const getIsOtherOptionSelected = (
  options: RadioGroupFieldOption[],
  value?: string | null,
) => Boolean(value) && !getIsValueFromOptions(options, value);

export const getOtherLabel = (addOtherLabel?: string, t?: TFunction) => {
  const otherLabelDefault = t?.('add-other.default-other-option-label');
  return addOtherLabel || otherLabelDefault || OTHER_ID;
};

export const getOtherValue = (value: string, addOtherLabel?: string) => {
  const addedSymbolsLength = 2; // we add ': ' to other value
  const otherLabelLength = addOtherLabel
    ? addOtherLabel.length + addedSymbolsLength
    : 0;
  return value.slice(otherLabelLength);
};
